import { makeAutoObservable } from "mobx";

let nextId = 1;

class ToastStore {
  toasts = [];

  constructor() {
    makeAutoObservable(this);
  }

  show(message, { color = "success", title, autohide = 5000 } = {}) {
    const id = nextId++;
    this.toasts.push({ id, message, color, title, autohide });
    // AppToaster only ever reads the latest entry; keep the backlog small.
    if (this.toasts.length > 20) this.toasts = this.toasts.slice(-20);
    return id;
  }

  success(message, opts) {
    return this.show(message, { ...opts, color: "success" });
  }

  error(message, opts) {
    return this.show(message, { ...opts, color: "danger", autohide: opts?.autohide ?? 8000 });
  }
}

const toastStore = new ToastStore();

export default toastStore;
